module.exports = __webpack_public_path__ + "img/九里香.ff3e8072.jpg";